// extracted by mini-css-extract-plugin
export default {"header_wrapper":"header_header_wrapper__-DIRM"};